import { render, staticRenderFns } from "./JoinDetails.vue?vue&type=template&id=78eb8583&scoped=true&"
import script from "./JoinDetails.vue?vue&type=script&lang=js&"
export * from "./JoinDetails.vue?vue&type=script&lang=js&"
import style0 from "./JoinDetails.vue?vue&type=style&index=0&id=78eb8583&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78eb8583",
  null
  
)

export default component.exports